<template>
    <div>
        <v-dialog width="350" v-model="show" persistent>
            <v-card>
                <v-card-title>Verification</v-card-title>
                <v-divider />
                <v-card-text>
                    <div class="d-flex justify-center mx-auto">
                        <div class="circle-container" :class="isMobile? 'mt-5' : 'mt-0'">
                            <v-icon class="d-flex justify-center" color="success" :size="isMobile ? 70 : 80">mdi-check-outline</v-icon>
                            <h4 class="d-block text-center">Payment verified</h4>
                        </div>
                    </div>
                </v-card-text>

                <v-card-actions>
                    <v-btn class="d-flex ml-auto" @click="show = false" color="error" text>Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <loading-dialog :show="loading"></loading-dialog>
    </div>
</template>


<script>
import LoadingDialog from "@ui/components/LoadingDialog";
export default {
    name: "Verification", 
    components: {
        LoadingDialog
    },
    data: () => ({
        loading: false, 
        show: false,
        DIALOG_DELAY: 100,
    }), 

    computed: {
        isMobile: function() {
            return this.$vuetify.breakpoint.xs
        }
    }, 

    watch: {
        show: function(val){
            if(val == false){
                this.redirect(); 
            }
        }
    },

    methods: {
        redirect() {
            return this.$router.push("/"); 
        }
    },

    created() {
        this.loading = true; 

        setTimeout(() => {
            this.show = true; 
        }, this.DIALOG_DELAY); 
    }
}
</script>
